import React, { PropsWithChildren, FC } from "react";
import Animated from "../Animated";

export type SlideDirection = "up" | "down" | "left" | "right";

export interface SlideProps extends PropsWithChildren<{}> {
  in: boolean;
  timeout?: number;
  direction?: SlideDirection;
  onExited?: () => void;
  unmountOnExit?: boolean;
}

const Slide: FC<SlideProps> = props => {
  const { children, in: inProp, timeout, direction = "up", ...rest } = props;

  return (
    <Animated
      appear
      in={inProp}
      name={`slide-${direction}`}
      timeout={timeout}
      {...rest}
    >
      {children}
    </Animated>
  );
};

export default Slide;
